import AlertModal from "../../../Components/Modals/AlertModal";
import { useTranslation } from "react-i18next";

const JobUnavailableModal = ({
  open,
  onClose,
  onActionClick,
  job_unavailable_reason,
}) => {
  const { t } = useTranslation("job-action-modals", {
    keyPrefix: "jobUnavailableModal",
  });
  return (
    <AlertModal
      {...{
        open,
        onClose,
        onActionClick,
        title: t("dialogTitle"),
        description:
          job_unavailable_reason === "JOB_CANCELED_BY_MEMBER"
            ? t("cancelledDescription")
            : t("otherDescription"),
        actionBtnText: t("actionBtnText"),
      }}
    />
  );
};

export default JobUnavailableModal;
